module.exports = __webpack_public_path__ + "static/media/dental_icon_one.2a14bbe1.svg";